import { useLocation, useNavigate } from 'react-router-dom'
import { TAB_HASHES } from '../utils/profileTabConfig'

export const useProfileNavigation = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const currentHash = location.hash || TAB_HASHES[0]
  const currentIndex = TAB_HASHES.indexOf(currentHash)

  const handleTabChange = (index: number) => {
    navigate(TAB_HASHES[index])
  }

  const handleHashChange = (hash: string) => {
    navigate(hash)
  }

  return {
    currentHash,
    currentIndex,
    handleTabChange,
    handleHashChange,
  }
}
